import { OrderTypes, WONumberPrefixes } from '../components';
import i18n from '../translations/i18n';
import { getDateTime } from './date';

export const completionTimeBuffer = 30;

export const assignTextOnLoading = (originalText, isLoading) => {
  let text = null;
  if (!isLoading && originalText) {
    text = originalText;
  } else if (!isLoading && !originalText) {
    text = i18n.t('global:errors.notAvailable');
  }
  return text;
};

export const getShortOrderNumber = woNumber => woNumber?.replace(/WO-/, '');

export const getOrderNumber = (woNumber, isLoading) =>
  !isLoading ? getShortOrderNumber(woNumber) : null;

export const estimatedTimeCompletion = (
  orders,
  factorOfBuffer = 1,
  onlyCompliance = false
) => {
  if (!orders) return null;
  const servicesCT =
    [orders, ...(orders?.relatedOrders || [])].reduce(
      (totalTime, order) =>
        totalTime +
        order.services.reduce(
          (time, service) => time + service.complianceTime,
          0
        ),
      completionTimeBuffer * factorOfBuffer
    ) ?? completionTimeBuffer;

  if (onlyCompliance) return servicesCT;

  return getDateTime(orders?.createdAt, { zone: 'utc' }).plus({
    minutes: servicesCT,
  });
};

export const getWOPrefix = orderType => {
  switch (orderType) {
    case OrderTypes.ESTIMATE:
      return WONumberPrefixes.ESTIMATES;
    case OrderTypes.RECONDITIONING:
      return WONumberPrefixes.PACKAGES;
    case OrderTypes.WORK_ORDER:
      return WONumberPrefixes.SIMPLE_ORDER;
    case OrderTypes.SERVICE_ORDER:
      return WONumberPrefixes.SERVICE_ORDER;
    default:
      return WONumberPrefixes.DEFAULT;
  }
};
